module.exports = __webpack_public_path__ + "img/banner04.7504aa32.jpg";